// extracted by mini-css-extract-plugin
module.exports = {"hostingPageWrapper":"Hosting_hostingPageWrapper__2Ce5E","hostingPage":"Hosting_hostingPage__2Tf9V","topImage":"Hosting_topImage__1BkJ3"};